export const emailTemplates = {
  membri: [
  {
  id: "prdp-membri-app",
  name: "Aplicația PRDP Membri",
  subject: "Descoperă cum contribui activ la viitorul partidului!",
  getContent: (data) => `
    <div style="max-width: 700px; margin: auto; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #222222; padding: 32px; background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%); border-radius: 14px; box-shadow: 0 8px 24px rgba(0, 53, 141, 0.15);">

      <!-- HEADER -->
      <div style="padding: 24px; background: #003580; border-radius: 12px 12px 0 0; text-align: center; box-shadow: inset 0 -4px 6px rgba(0, 53, 141, 0.4);">
        <h1 style="color: #f0f7ff; margin: 0; font-size: 28px; letter-spacing: 1.2px; font-weight: 700; font-family: 'Arial Black', Gadget, sans-serif;">
          PRDP Membri – Platforma care transformă implicarea ta în rezultate
        </h1>
      </div>

      <!-- CONTENT -->
      <div style="padding: 30px 36px; background: #ffffff; border-radius: 0 0 12px 12px; font-size: 17px; line-height: 1.65; box-shadow: 0 8px 16px rgba(3, 35, 85, 0.1);">

        <p style="font-weight: 600; font-size: 18px; margin-bottom: 22px;">
          Imaginează-ți o comunitate politică unită, modernă, în care fiecare membru contează nu doar prin voce, ci și prin faptele sale. Acolo unde ideile prind viață, iar munca depusă este recunoscută și răsplătită. Acesta este spiritul în care a fost creată aplicația PRDP Membri, disponibilă la adresa <a href="http://membri.prdp.ro" style="color: #007bff; font-weight: 700;">membri.prdp.ro</a>.
        </p>

        <p style="margin-bottom: 20px;">
          Autentificarea este simplă: folosești adresa de e-mail pe care primești notificările oficiale de la PRDP și parola standard <code style="background:#f3f9ff; padding:2px 6px; border-radius:4px; font-weight:bold;">prdp2025</code> (o parolă pe care o vei putea ulterior schimba). Din acest moment intri într-un spațiu gândit pentru tine și pentru viitorul partidului.
        </p>

        <h2 style="color: #003580; font-weight: 700; margin-top: 32px; margin-bottom: 16px; border-bottom: 3px solid #007bff; padding-bottom: 6px; font-size: 22px;">
          O platformă unde ideile devin realitate
        </h2>

        <p style="margin-bottom: 20px;">
          Aplicația îți oferă posibilitatea să <strong>propui proiecte</strong> care pot fi preluate, discutate și transformate în inițiative reale. Colegii le pot susține cu voturi, iar cei mai activi membri pot deveni adevărați catalizatori ai schimbării.
        </p>

        <h2 style="color: #003580; font-weight: 700; margin-top: 32px; margin-bottom: 16px; border-bottom: 3px solid #007bff; padding-bottom: 6px; font-size: 22px;">
          Puncte care valorează încredere și viitor
        </h2>

        <p style="margin-bottom: 12px;">Fiecare acțiune contează și este recunoscută:</p>
        <ul style="margin-bottom: 24px; padding-left: 20px; color: #555;">
          <li>aduci membri noi și primești puncte,</li>
          <li>plătești la timp cotizația și primești puncte,</li>
          <li>finalizezi cursurile interne și participi la evenimente,</li>
          <li>aduci sponsori, găsești susținători, contribui prin donații sau prin publicitate pentru partid.</li>
        </ul>

        <p style="margin-bottom: 20px;">
          Aceste puncte nu sunt simple cifre. Ele devin <strong>criterii-cheie</strong> nu doar pentru stabilirea listelor de candidați, ci și pentru <strong>obținerea unor funcții de conducere în partid</strong> sau pentru a participa la <strong>conferințe naționale și internaționale</strong>. Fiecare gest de implicare înseamnă un pas mai aproape de liderii pe care ni-i dorim pentru viitor.
        </p>

        <h2 style="color: #003580; font-weight: 700; margin-top: 32px; margin-bottom: 16px; border-bottom: 3px solid #007bff; padding-bottom: 6px; font-size: 22px;">
          Biblioteca Digitală – locul unde crești ca lider
        </h2>

        <p style="margin-bottom: 20px;">
          În aplicație ai acces la <strong>carte, idei și cunoaștere</strong>. Biblioteca Digitală îți pune la dispoziție volume, materiale și cursuri care te ajută să devii un membru mai bine pregătit, mai informat și mai influent în comunitatea ta.
        </p>

        <h2 style="color: #003580; font-weight: 700; margin-top: 32px; margin-bottom: 16px; border-bottom: 3px solid #007bff; padding-bottom: 6px; font-size: 22px;">
          Evenimente care apropie și unesc
        </h2>

        <p style="margin-bottom: 20px;">
          Ai o zonă dedicată unde poți vedea <strong>toate evenimentele partidului</strong>, te poți înscrie cu un singur click și îți poți planifica participarea. Prezența ta contează nu doar prin oameni, ci și prin legături și idei care prind viață atunci când suntem împreună.
        </p>

        <h2 style="color: #003580; font-weight: 700; margin-top: 32px; margin-bottom: 16px; border-bottom: 3px solid #007bff; padding-bottom: 6px; font-size: 22px;">
          Mai mult decât o aplicație. O comunitate.
        </h2>

        <p style="margin-bottom: 20px;">
          PRDP Membri nu este doar o platformă digitală, ci un <strong>spațiu de apartenență</strong>. Este modul prin care ne aducem vocea împreună, transparent și meritocratic. Este locul unde se văd eforturile fiecăruia și unde viitorul partidului se scrie prin implicare.
        </p>

        <p>
          Pentru că în PRDP, fiecare membru contează, iar fiecare pas pe care îl faci alături de noi te aduce mai aproape de comunitatea pe care o clădim împreună.
        </p>

        <p style="font-weight: 700; font-size: 18px; margin-top: 30px;">
          Intră acum pe <a href="http://membri.prdp.ro" style="color: #007bff; font-weight: 700;">membri.prdp.ro</a>, loghează-te și descoperă cum viitorul partidului se scrie chiar prin tine.
        </p>

        <!-- FOOTER -->
        <hr style="margin: 32px 0; border: none; border-top: 1px solid #ddd;" />
        <div style="font-size: 14px; color: #888888; text-align: center;">
          <p>Cu respect,<br />Echipa PRDP</p>
          <p>
            <a href="https://www.prdp.ro" style="color: #007bff; text-decoration: none;">www.prdp.ro</a><br />
            Facebook / Instagram: <strong>@partidulprdp</strong>
          </p>
        </div>
      </div>
    </div>
  `
},  
  {
    id: "manifest-prdp",
    name: "Manifest PRDP",
    subject: "Împreună construim o Românie dreaptă și puternică",
    getContent: (data) => `
      <div style="max-width: 700px; margin: auto; font-family: Arial, sans-serif; color: #2b2b2b; padding: 24px; background-color: #f5f6fa; border-radius: 12px;">
        
        <!-- HEADER -->
        <div style="padding: 20px; background-color: #01358d; border-radius: 8px 8px 0 0; text-align: center;">
          <h1 style="color: #ffffff; margin: 0; font-size: 22px;">PRDP – Vocea ta, Viitorul României</h1>
        </div>
        
        <!-- CONTENT -->
        <div style="padding: 30px; background-color: #ffffff; border-radius: 0 0 8px 8px; line-height: 1.6; font-size: 16px;">
          
          <p>Stimate/Stimată <strong>${data.prenume} ${data.nume}</strong>,</p>
          
          <p><strong>PRDP nu este doar un partid.</strong> Este o forță a societății civile, născută din frustrarea și speranța unei națiuni. Suntem oameni care au înțeles că schimbarea nu vine de la sine, ci se construiește, pas cu pas, de jos în sus.</p>
          
          <p><strong>Nu promitem iluzii.</strong> Promitem fapte. PRDP este despre școlile uitate, despre infrastructura care întârzie de 30 de ani, despre spitale care trebuie să respecte demnitatea umană. Este despre soluții reale și proiecte concrete.</p>
          
          <p><strong>PRDP este vocea ta:</strong> a studentului care vrea să rămână în țară, a pensionarului care așteaptă respect și o pensie decentă, a antreprenorului care vrea mai puțină birocrație. Este vocea celor mulți, uniți într-un singur glas puternic.</p>
          
          <p>Nu avem sedii luxoase, mașini de lux sau bugete nelimitate. Avem entuziasmul tinerilor, înțelepciunea celor vârstnici și experiența celor care au muncit cu onestitate. PRDP este o <strong>mişcare de masă</strong>, o trezire, un curent de schimbare.</p>
          
          <p><strong>Schimbarea nu vine peste noapte.</strong> Dar vine prin pași mici și siguri, prin încrederea redată oamenilor și prin voința colectivă. Fiecare reușită, oricât de mică, devine o cărămidă la temelia unei Românii noi.</p>
          
          <blockquote style="border-left: 4px solid #01358d; margin: 20px 0; padding-left: 16px; font-style: italic; color:#444;">
            PRDP nu este o utopie. Este o necesitate pentru România. Este șansa noastră comună. <br/>
            Împreună schimbăm România. Împreună suntem <strong>Vocea ta, Viitorul României</strong>.
          </blockquote>
          
          <!-- CALL TO ACTION -->
          <div style="margin: 32px 0; text-align: center;">
            <a href="https://www.prdp.ro/contact" target="_blank"
               style="display: inline-block; background-color: #01358d; color: #ffffff; padding: 14px 28px;
                      text-decoration: none; border-radius: 6px; font-weight: bold; font-size: 16px;">
              Implică-te alături de noi
            </a>
          </div>
          
          <p style="margin-top:24px;">Pentru detalii și implicare, ne poți scrie la <a href="mailto:contact@prdp.ro" style="color: #01358d; font-weight: bold;">contact@prdp.ro</a>.</p>
          
          <!-- FOOTER -->
          <hr style="margin: 24px 0; border: none; border-top: 1px solid #eee;" />
          <div style="font-size: 14px; color: #777777; text-align: center;">
            <p>Cu respect,<br/>Echipa PRDP</p>
            <p>
              <a href="https://www.prdp.ro" style="color: #01358d; text-decoration: none;">www.prdp.ro</a><br/>
              Facebook / Instagram: <strong>@partidulprdp</strong>
            </p>
          </div>
        </div>
      </div>`
  },
    {
      id: "notificare-plata-cotizatie",
      name: "Notificare plată cotizație",
      subject: "Notificare plată cotizație lunară PRDP",
      getContent: (data) => `
        <div style="max-width: 600px; margin: auto; font-family: Arial, sans-serif; color: #2b2b2b; padding: 24px; background-color: #f9f9f9; border-radius: 12px;">
          <div style="padding: 16px; background-color: #01358d; border-radius: 8px 8px 0 0; text-align: center;">
            <h2 style="color: white; margin: 0;">PRDP – Notificare plată cotizație</h2>
          </div>
          <div style="padding: 24px; background-color: white; border-radius: 0 0 8px 8px;">
            <p>Stimate/Stimată <strong>${data.prenume} ${data.nume}</strong>,</p>
            <p>Vă reamintim că, potrivit statutului PRDP, cotizația de membru se achită în intervalul <b>1-5 ale fiecărei luni</b>.</p>
            <p>Puteți achita rapid cotizația pentru luna curentă accesând linkul de mai jos:</p>
            <div style="margin: 32px 0; text-align: center;">
              <a href="https://www.prdp.ro/cotizatii" target="_blank"
                 style="display: inline-block; background-color: #01358d; color: #ffffff; padding: 12px 24px;
                        text-decoration: none; border-radius: 6px; font-weight: bold;">
                Plătește cotizația online
              </a>
            </div>
            <p>Susținerea ta financiară permite partidului să deruleze proiecte și acțiuni pentru o Românie dreaptă și prosperă.</p>
            <p>În cazul în care ați efectuat deja plata, vă mulțumim și puteți ignora acest mesaj.</p>
            <p style="margin-top:24px;">Pentru orice întrebări sau detalii ne puteți contacta la <a href="mailto:contact@prdp.ro" style="color: #01358d; font-weight: bold;">contact@prdp.ro</a>.</p>
            <hr style="margin: 24px 0; border: none; border-top: 1px solid #eee;" />
            <div style="font-size: 14px; color: #777777; text-align: center;">
              <p>Cu stimă,<br/>Echipa PRDP</p>
              <p><a href="https://www.prdp.ro" style="color: #01358d; text-decoration: none;">www.prdp.ro</a><br/>Facebook / Instagram: <strong>@partidulprdp</strong></p>
            </div>
          </div>
        </div>`
    },
    {
      id: "confirmare-plata-cotizatie",
      name: "Confirmare plată cotizație",
      subject: "Confirmare plată cotizație lunară PRDP",
      getContent: (data) => `
        <div style="max-width: 600px; margin: auto; font-family: Arial, sans-serif; color: #2b2b2b; padding: 24px; background-color: #f9f9f9; border-radius: 12px;">
          <div style="padding: 16px; background-color: #01358d; border-radius: 8px 8px 0 0; text-align: center;">
            <h2 style="color: white; margin: 0;">PRDP – Confirmare plată cotizație</h2>
          </div>
          <div style="padding: 24px; background-color: white; border-radius: 0 0 8px 8px;">
            <p>Stimate/Stimată <strong>${data.prenume} ${data.nume}</strong>,</p>
            <p>Vă mulțumim! Plata cotizației lunare a fost înregistrată cu succes în sistemul PRDP.</p>
            <p>Susținerea ta permite implicarea în proiecte importante pentru membrii și simpatizanții partidului.</p>
            <h3 style="font-size: 18px; color: #01358d; margin-top: 36px;">🔵 Beneficii:</h3>
            <ul style="margin-left: 18px;">
              <li>Poți participa la voturi interne, inițiative și evenimente PRDP</li>
              <li>Punctele de membru vor fi actualizate</li>
            </ul>
            <p style="margin-top:24px;">Pentru orice întrebări contactează-ne la <a href="mailto:contact@prdp.ro" style="color: #01358d; font-weight: bold;">contact@prdp.ro</a>.</p>
            <hr style="margin: 24px 0; border: none; border-top: 1px solid #eee;" />
            <div style="font-size: 14px; color: #777777; text-align: center;">
              <p>Cu stimă,<br/>Echipa PRDP</p>
              <p><a href="https://www.prdp.ro" style="color: #01358d; text-decoration: none;">www.prdp.ro</a><br/>Facebook / Instagram: <strong>@partidulprdp</strong></p>
            </div>
          </div>
        </div>`
    },
    {
      id: "depasire-termen-cotizatie",
      name: "Notificare depășire termen plată cotizație",
      subject: "Reminder: Depășire termen plată cotizație PRDP",
      getContent: (data) => {
        // Obținem automat numele lunii curente în formatul "long" (ex: "august") pentru limba română ('ro-RO')
        const lunaCurentaRaw = new Intl.DateTimeFormat('ro-RO', { month: 'long' }).format(new Date());
        // Convertim prima literă în majusculă pentru o afișare corectă (ex: "August")
        const lunaCurenta = lunaCurentaRaw.charAt(0).toUpperCase() + lunaCurentaRaw.slice(1);

        return `
        <div style="max-width: 600px; margin: auto; font-family: Arial, sans-serif; color: #2b2b2b; padding: 24px; background-color: #f9f9f9; border-radius: 12px;">
          <div style="padding: 16px; background-color: #c82333; border-radius: 8px 8px 0 0; text-align: center;">
            <h2 style="color: white; margin: 0;">PRDP – Reminder plată cotizație</h2>
          </div>
          <div style="padding: 24px; background-color: white; border-radius: 0 0 8px 8px;">
            <p>Stimate/Stimată <strong>${data.prenume} ${data.nume}</strong>,</p>
            <p>Vă aducem la cunoștință că nu ați achitat cotizația de membru pentru luna <b>${lunaCurenta}</b>, iar termenul de plată a fost depășit.</p>
            <p>Conform statutului PRDP, neplata cotizației poate atrage suspendarea calității de membru. Pentru a evita acest lucru, vă rugăm să efectuați plata în cel mai scurt timp posibil.</p>
            <div style="margin: 32px 0; text-align: center;">
              <a href="https://www.prdp.ro/cotizatii" target="_blank"
                 style="display: inline-block; background-color: #c82333; color: #ffffff; padding: 12px 24px;
                        text-decoration: none; border-radius: 6px; font-weight: bold;">
                Plătește acum cotizația
              </a>
            </div>
            <p>Înțelegem că pot apărea situații neprevăzute. Dacă întâmpinați dificultăți sau ați efectuat deja plata, vă rugăm contactați echipa în cel mai scurt timp pentru a clarifica situația.</p>
            <p style="margin-top:24px;">Ne puteți scrie la <a href="mailto:contact@prdp.ro" style="color: #01358d; font-weight: bold;">contact@prdp.ro</a>.</p>
            <hr style="margin: 24px 0; border: none; border-top: 1px solid #eee;" />
            <div style="font-size: 14px; color: #777777; text-align: center;">
              <p>Cu stimă,<br/>Echipa PRDP</p>
              <p><a href="https://www.prdp.ro" style="color: #01358d; text-decoration: none;">www.prdp.ro</a><br/>Facebook / Instagram: <strong>@partidulprdp</strong></p>
            </div>
          </div>
        </div>`
      }
    },
    {
      id: "multumire-donatie-prdp",
      name: "Mulțumire pentru donație PRDP",
      subject: "Îți mulțumim pentru donație! Fiecare leu contează în lupta pentru România Dreaptă și Prosperă",
      getContent: (data) => `
        <div style="font-family: Arial, sans-serif; max-width: 700px; margin: auto; color: #2b2b2b; background-color: #fefefe; padding: 24px;">
          <p>Dragă <strong>${data.prenume} ${data.nume}</strong>,</p>

          <p>Îți mulțumim din inimă pentru donația ta către Partidul România Dreaptă și Prosperă (PRDP).<br/>
          Gestul tău onorează și obligă. La PRDP, fiecare contribuție este o piatră de temelie a unei construcții curate, românești și drepte.</p>

          <p><strong>💬 Mesaj din partea Fondatorului:</strong></p>

          <blockquote style="font-style: italic; color: #444; border-left: 4px solid #01358d; padding-left: 12px;">
            „Când nu ai milionari controversați, nu ai contracte cu statul și nu te plătește niciun grup de interese, singura ta forță sunt oamenii sinceri, care cred în ce faci.<br/>
            Iar dacă tu ai ales să donezi, înseamnă că ești deja parte din ceva mai mare decât tine: un vis pentru o Românie Dreaptă și Prosperă.<br/>
            Îți sunt recunoscător.”<br/>
            — Alin Claudiu Mureanu, Președinte Fondator
          </blockquote>

          <hr/>

          <p><strong>🎯 Punctajul tău contează!</strong></p>

          <p>În semn de recunoștință, pentru fiecare leu donat primești 1 punct PRDP.<br/>
          Punctajul este esențial pentru eligibilitatea la funcții, candidaturi pe listele electorale și implicare.</p>

          <p>Vom actualiza punctajul în cel mai scurt timp și vei primi notificări despre oportunități și poziții în partid.</p>

          <hr/>

          <p><strong>🤝 Nu avem sponsori din umbră.</strong><br/>
          PRDP nu este finanțat de afaceriști controversați sau grupuri obscure.<br/>
          Totul se bazează pe buzunarele membrilor și simpatizanților noștri.</p>

          <hr/>

          <p>Dacă vrei să te implici mai mult, scrie-ne oricând.<br/>
          📩 Contact: <a href="mailto:contact@prdp.ro">contact@prdp.ro</a></p>

          <p>Îți mulțumim că ești alături de noi!<br/>
          Fără tine, PRDP ar fi doar un vis, cu tine devine realitate.</p>

          <p><strong>Cu respect și recunoștință,<br/>
          Echipa PRDP</strong></p>

          <p>🐝 Dreptate. Credință. Prosperitate.</p>
        </div>
      `
    }
  ],
  voluntari: [
    {
    id: "manifest-prdp",
    name: "Manifest PRDP",
    subject: "Împreună construim o Românie dreaptă și puternică",
    getContent: (data) => `
      <div style="max-width: 700px; margin: auto; font-family: Arial, sans-serif; color: #2b2b2b; padding: 24px; background-color: #f5f6fa; border-radius: 12px;">
        
        <!-- HEADER -->
        <div style="padding: 20px; background-color: #01358d; border-radius: 8px 8px 0 0; text-align: center;">
          <h1 style="color: #ffffff; margin: 0; font-size: 22px;">PRDP – Vocea ta, Viitorul României</h1>
        </div>
        
        <!-- CONTENT -->
        <div style="padding: 30px; background-color: #ffffff; border-radius: 0 0 8px 8px; line-height: 1.6; font-size: 16px;">
          
          <p>Stimate/Stimată <strong>${data.prenume} ${data.nume}</strong>,</p>
          
          <p><strong>PRDP nu este doar un partid.</strong> Este o forță a societății civile, născută din frustrarea și speranța unei națiuni. Suntem oameni care au înțeles că schimbarea nu vine de la sine, ci se construiește, pas cu pas, de jos în sus.</p>
          
          <p><strong>Nu promitem iluzii.</strong> Promitem fapte. PRDP este despre școlile uitate, despre infrastructura care întârzie de 30 de ani, despre spitale care trebuie să respecte demnitatea umană. Este despre soluții reale și proiecte concrete.</p>
          
          <p><strong>PRDP este vocea ta:</strong> a studentului care vrea să rămână în țară, a pensionarului care așteaptă respect și o pensie decentă, a antreprenorului care vrea mai puțină birocrație. Este vocea celor mulți, uniți într-un singur glas puternic.</p>
          
          <p>Nu avem sedii luxoase, mașini de lux sau bugete nelimitate. Avem entuziasmul tinerilor, înțelepciunea celor vârstnici și experiența celor care au muncit cu onestitate. PRDP este o <strong>mişcare de masă</strong>, o trezire, un curent de schimbare.</p>
          
          <p><strong>Schimbarea nu vine peste noapte.</strong> Dar vine prin pași mici și siguri, prin încrederea redată oamenilor și prin voința colectivă. Fiecare reușită, oricât de mică, devine o cărămidă la temelia unei Românii noi.</p>
          
          <blockquote style="border-left: 4px solid #01358d; margin: 20px 0; padding-left: 16px; font-style: italic; color:#444;">
            PRDP nu este o utopie. Este o necesitate pentru România. Este șansa noastră comună. <br/>
            Împreună schimbăm România. Împreună suntem <strong>Vocea ta, Viitorul României</strong>.
          </blockquote>
          
          <!-- CALL TO ACTION -->
          <div style="margin: 32px 0; text-align: center;">
            <a href="https://www.prdp.ro/contact" target="_blank"
               style="display: inline-block; background-color: #01358d; color: #ffffff; padding: 14px 28px;
                      text-decoration: none; border-radius: 6px; font-weight: bold; font-size: 16px;">
              Implică-te alături de noi
            </a>
          </div>
          
          <p style="margin-top:24px;">Pentru detalii și implicare, ne poți scrie la <a href="mailto:contact@prdp.ro" style="color: #01358d; font-weight: bold;">contact@prdp.ro</a>.</p>
          
          <!-- FOOTER -->
          <hr style="margin: 24px 0; border: none; border-top: 1px solid #eee;" />
          <div style="font-size: 14px; color: #777777; text-align: center;">
            <p>Cu respect,<br/>Echipa PRDP</p>
            <p>
              <a href="https://www.prdp.ro" style="color: #01358d; text-decoration: none;">www.prdp.ro</a><br/>
              Facebook / Instagram: <strong>@partidulprdp</strong>
            </p>
          </div>
        </div>
      </div>`
  },
  ]
};
